exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen and (max-width:768px){p[_v-4ae6ca21]{font-size:3.2vw}}", "", {"version":3,"sources":["/./src/components/Categorie.vue"],"names":[],"mappings":"AA4FA,oCACE,eACE,eAAiB,CAClB,CACF","file":"Categorie.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 768px){\n  p[_v-4ae6ca21]{\n    font-size: 3.2vw;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-4ae6ca21&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/components/Categorie.vue
// module id = 331
// module chunks = 0